import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IntrackFeatureModule } from '../../../intrack-feature.module';
import { DatepickerModule } from '../../datepicker/datepicker.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ActionButtonModule } from '../../action-button/action-button.module';
import { NgxsModule } from '@ngxs/store';
import { ReasonCodeState } from '../../../store/state/monitoring/reason-code/reason-code.state';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StatusCodeState } from '../../../store/state/monitoring/status-code/status-code.state';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { MonitoringProfilesModule } from '../profiles/monitoring-profiles.module';
import { MonitoringReportItemComponent } from './item/monitoring-report-item.component';
import { MatChipsReportColumnsDialogComponent } from './mat-chips-report-columns-dialog/mat-chips-report-columns-dialog.component';
import { MonitoringReportComponent } from './monitoring-report.component';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';

@NgModule({
  declarations: [MonitoringReportComponent, MonitoringReportItemComponent, MatChipsReportColumnsDialogComponent],
  imports: [
    IntrackFeatureModule,
    DatepickerModule,
    ActionButtonModule,
    DragDropModule,
    PipesModule,
    TranslateModule.forChild({}),
    NgxsModule.forFeature([ReasonCodeState, StatusCodeState]),
    MatTooltipModule,
    MonitoringProfilesModule,
    SvgIconModule,
  ],
  exports: [MonitoringReportComponent, MonitoringReportItemComponent],
})
export class MonitoringReportModule {}
